import { render, staticRenderFns } from "./CustomerAccountForm.vue?vue&type=template&id=c4412964&scoped=true"
import script from "./CustomerAccountForm.vue?vue&type=script&lang=ts"
export * from "./CustomerAccountForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4412964",
  null
  
)

export default component.exports